import React from 'react';

const iconBtnSend = '/icons/btn-send.png';
import './ButtonUserBar.style.scss';

const ButtonUserBar = () => {
  return (
    <div className="user-send">
      <button
        id="enviar-mensagem"
        data-testid="send-message"
        data-aut-test="send-message"
        className="btn-send-message"
      >
        <img src={iconBtnSend} alt="Ícone de seta para envio" />
      </button>
    </div>
  );
};

export default ButtonUserBar;
